namespace Portico.Models.Setup {

    export interface IPortalDataGroup {
		id: string;
		portalId: string;
		dataGroupId: string;
        priority: number;
		createdBy: number;
		createdOn: Date;

        dataGroup: DataGroup;

		getDataRows(dataTableId: string, key?: string): DataRow[];
	}

    export class PortalDataGroup implements IPortalDataGroup {
		id: string;
		portalId: string;
		dataGroupId: string;
        priority: number;
		createdBy: number;
		createdOn: Date;

        dataGroup: DataGroup;

        constructor(obj?: IPortalDataGroup) {
            this.id = null;
            this.portalId = null;
            this.dataGroupId = null;
            this.priority = null;
			this.createdBy = null;
			this.createdOn = null;

            this.dataGroup = null;

            if (obj) {
                this.id = obj.id;
                this.portalId = obj.portalId;
                this.dataGroupId = obj.dataGroupId;
                this.priority = obj.priority;
				this.createdBy = obj.createdBy;
				this.createdOn = obj.createdOn ? new Date(typeof obj.createdOn === 'string' && (<string>obj.createdOn).charAt(10) === 'T' ? obj.createdOn + 'Z' : obj.createdOn) : null;

                if (obj.dataGroup) {
                    this.dataGroup = new DataGroup(obj.dataGroup);
                }
            }
        }

		getDataRows(dataTableId: string, key: string = null): DataRow[] {
			return this.dataGroup ? this.dataGroup.getDataRows(dataTableId, key) : [];
		}
    }
}